import { useState } from "react";
import { sanitizeMobile, isValidMobile } from "@/lib/format";

// Reusable 10-digit Indian mobile input: digits-only, maxLength 10,
// inline red error + red border when invalid on blur.
export default function MobileInput({ value, onChange, testid, placeholder = "10-digit mobile", className = "a1-input" }) {
  const [touched, setTouched] = useState(false);
  const invalid = touched && value && !isValidMobile(value);
  return (
    <>
      <input
        data-testid={testid}
        type="tel"
        inputMode="numeric"
        maxLength={10}
        className={`${className}${invalid ? " border-red-500" : ""}`}
        value={value}
        placeholder={placeholder}
        onBlur={() => setTouched(true)}
        onChange={(e) => onChange(sanitizeMobile(e.target.value))}
      />
      {invalid && <p className="text-red-500 text-xs font-semibold mt-1">Please enter a valid 10-digit mobile number</p>}
    </>
  );
}
